import { useContext, useState } from 'react';
import { ArrowBack } from '@mui/icons-material';
import {
  BoxSection,
  ButtonDefault,
  ButtonPrimary,
  Heading3,
  TextM,
  TextS,
  Upload,
} from 'app/components';
import { StepContentButtonsArea } from '../styles';
import { CustomCcbArea, CustomCcbAreaText } from './styles';
import { ApplicationRequestContext } from '../ApplicationRequest';
import useApplicationService from 'modules/products/services/hooks/useApplicationsService';

const CustomCcbStep = () => {
  const { uploadCustomCcbTemplate, loadings } = useApplicationService();
  const { onBack, onForward, setCustomCcbTemplateId, customCcbTemplateId } =
    useContext(ApplicationRequestContext);
  const [fileName, setFileName] = useState<string | null>(null);

  const onSubmit = () => {
    onForward();
  };

  const handleDrop = (acceptedFiles: File[]) => {
    const formData = new FormData();
    formData.append('file', acceptedFiles[0]);
    uploadCustomCcbTemplate(formData).then((res) => {
      if (res) {
        setCustomCcbTemplateId(res.id);
        setFileName(acceptedFiles[0].name);
      }
    });
  };

  return (
    <BoxSection>
      <Heading3>Template de CCB</Heading3>
      <TextS style={{ marginTop: '5px' }}>
        Envie o template da CCB para emissão
      </TextS>
      <CustomCcbArea>
        {fileName && (
          <CustomCcbAreaText>
            <TextM weight="Bold">{fileName}</TextM>
          </CustomCcbAreaText>
        )}
        <Upload
          handleDrop={handleDrop}
          loading={loadings.isUploadCustomCcbTemplateLoading}
          accept={{
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              [],
          }}
        />
      </CustomCcbArea>
      <StepContentButtonsArea>
        <ButtonDefault margin={true} onClick={onBack}>
          <ArrowBack />
        </ButtonDefault>
        <ButtonPrimary onClick={onSubmit}>
          {customCcbTemplateId ? 'Avançar' : 'Pular'}
        </ButtonPrimary>
      </StepContentButtonsArea>
    </BoxSection>
  );
};

export default CustomCcbStep;
